import axios from "axios";
import { store } from "../../store";

type CreateOpeningHourProps = {
  languageId: number;
  constantId: number;
};

export async function createOpeningHourAction({
  languageId,
  constantId,
}: CreateOpeningHourProps) {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const { name } = store.getState().openingHours;
  const dataToSend = {
    languageId,
    constantId,
    name,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/opening-hours`,
      dataToSend,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
